module.exports = __webpack_public_path__ + "img/SPLightMode.d27c7ed2.png";